module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUBAMAAABPKxEfAAAAKlBMVEUAAAAmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQmlvQ7TesMAAAADXRSTlMA8d9/WyAOxTqlo8Q75WkAuwAAAENJREFUCNdjWMYAAZcaIPTdy1D67lYofdEBQt+9lQCh72pA6bsGUPp6AIS+KwKnEeIIdToQfTcTUMwthdqL6o5pEAoA/C0+yDsAXXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/rightStrangle.png
// module id = SwSo
// module chunks = 1